// extracted by mini-css-extract-plugin
module.exports = {"inner":"_25d45facb5--inner--U8IF1"};